module.exports = __webpack_public_path__ + "assets/img/btn-detail-e106f488.png";